import { createReducer } from '../../utils';
import types from './types';

export const initialState = {
    isBackToTopButtonShown: false
};

const ACTION_HANDLERS = {
    [types.SHOW_BACK_TO_TOP_BUTTON]: state => ({
        ...state,
        isBackToTopButtonShown: true
    }),

    [types.HIDE_BACK_TO_TOP_BUTTON]: state => ({
        ...state,
        isBackToTopButtonShown: false
    })
};

export default createReducer(ACTION_HANDLERS, initialState);
